class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.label = this.querySelector('.search-label');
    this.updateLabelVisibility();

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
          this.updateLabelVisibility(event);
        }, 300).bind(this)
      );

      this.input.addEventListener('input', this.updateLabelVisibility.bind(this));
      this.input.addEventListener('focus', this.hideLabelOnFocus.bind(this));
      this.input.addEventListener('blur', this.updateLabelVisibility.bind(this));

    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  updateLabelVisibility() {
    console.log('updateLabelVisibility');
    if (this.input.value !== '') {
      this.label.classList.add('visually-hidden');
    } else {
      this.label.classList.remove('visually-hidden');
    }
  }

  hideLabelOnFocus() {
    console.log('hideLabelOnFocus');
    this.label.classList.add('visually-hidden');
  }
}

customElements.define('search-form', SearchForm);
